/**
 * Shared near-black scrim gradients for text-on-image overlays.
 *
 * Design decision: Near-black (not teal) so photography colors come through.
 * Gradient is localized to the bottom where text sits — top of image is untouched.
 */

/** Standard bottom-up scrim for cards and grid cells */
export const SCRIM_GRADIENT = 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.5) 25%, rgba(0,0,0,0.1) 50%, transparent 65%)';

/** Lighter scrim for small/strip cards where less text needs protection */
export const SCRIM_GRADIENT_LIGHT = 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.35) 30%, transparent 60%)';

/** Feature-card scrim — heavier for larger headlines */
export const SCRIM_GRADIENT_HEAVY = 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.6) 30%, rgba(0,0,0,0.15) 55%, transparent 70%)';
